export enum MatureArticleModalInterface {
  AgeConfirmation = "ageConfirmation",
}
